import { api } from '@/shared/api/client';
import type {
  Company,
  CreateCompanyRequest,
  UpdateCompanyRequest,
} from '@/shared/api/types/tenant';

export function listCompaniesByTenant(tenantId: string): Promise<Company[]> {
  return api.get<Company[]>(`/api/company/by-tenant/${tenantId}`);
}

export function createCompany(
  tenantId: string,
  req: CreateCompanyRequest,
): Promise<Company> {
  return api.post<Company>(`/api/company?tenantId=${tenantId}`, req);
}

export function updateCompany(id: string, req: UpdateCompanyRequest): Promise<Company> {
  return api.patch<Company>(`/api/company/${id}`, req);
}

export function syncCompanyTaxInfo(id: string): Promise<Company> {
  return api.post<Company>(`/api/company/${id}/sync-tax-info`);
}

export interface NotificationRecipient {
  AppUserId: string;
  DisplayName: string;
  Email: string;
}

export function listNotificationRecipients(companyId: string): Promise<NotificationRecipient[]> {
  return api.get<NotificationRecipient[]>(`/api/company/${companyId}/notification-recipients`);
}
